import { getStaticProps as pageGetStaticProps } from '@/pages/pokoje/[slug]'
export { default, getStaticPaths } from '@/pages/pokoje/[slug]'

export function getStaticProps(ctx: any) {
  return pageGetStaticProps({ ...ctx, locale: 'en' })
}
